module.exports = __webpack_public_path__ + "img/silver.5e9f47e6.png";